import { ResumePetisSimulationProposalClientResponse } from '../../../@types/ResumePetisSimulationProposal'
import { SubmitProposalClientResponse } from '../../../@types/SubmitProposal'
import { useSubmitProposalStore } from '../../../Stores/useSubmitProposalStore'

export const useSubmitProposalHydration = () => {
  const { setSubmitProposal } = useSubmitProposalStore()

  const handleSubmitProposalHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const firstReceipt = data.processData?.firstReceipt
    const policyData = data.processData?.policyData
    const proposalData = data.processData?.proposalData

    const submitProposal: SubmitProposalClientResponse = {
      policyId: policyData?.policyId || '',
      policyStatus:
        policyData?.policyStatusCode || proposalData?.policyStatus || '',
      policySubStatusDescription:
        policyData?.policySubStatusDescription ||
        proposalData?.policySubStatusDescription ||
        '',
      firstReceiptInfo: {
        invoiceId: firstReceipt?.invoiceId || '',
        invoiceNumber: String(firstReceipt?.invoiceNumber) || '',
        dueDate: firstReceipt?.dueDate || '',
        invoiceType: firstReceipt?.invoiceType || '',
        status: firstReceipt?.invoiceStatus || '',
        invoiceValue: Number(firstReceipt?.invoiceValue) || 0,
      },
      documents: policyData?.documentList?.map((doc) => ({
        name: doc.name || '',
        externalId: doc.externalId || '',
        type: doc.documentType || '',
        managementSystemCode: doc.managementSystemCode || '',
        // code: '',
        keyRef: doc.keyRef || '',
        hasSignature: doc.hasSignature,
        documentSignatureType: doc.signatureType || '',
        signatureStatus: doc.signatureType || '',
      })),
    }

    setSubmitProposal(submitProposal)
  }

  return { handleSubmitProposalHydration }
}
